var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.708 3.662c-.243-1.499-1.395-2.559-2.573-2.368-1.178.191-1.936 1.561-1.693 3.06.243 1.499 1.395 2.559 2.573 2.368C9.193 6.53 9.95 5.16 9.708 3.662z",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.266 12.692C7.266 10.653 8.938 9 11 9c2.062 0 4.2 1.653 4.2 3.692 0 .553.332 1.097.824 1.357A3.687 3.687 0 0118 17.308C18 19.347 16.328 21 14.266 21a3.742 3.742 0 01-2.78-1.227c-.244-.27-.729-.27-.974 0A3.742 3.742 0 017.732 21C5.672 21 4 19.347 4 17.308c0-1.723.81-3.168 2.449-3.576.464-.115.817-.566.817-1.04z",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.637 8.597c-.646-1.069-1.85-1.523-2.69-1.016-.84.508-.998 1.786-.352 2.855.647 1.07 1.852 1.524 2.692 1.016.84-.508.997-1.786.35-2.855zM12.44 3.714c.242-1.5 1.394-2.56 2.572-2.368 1.178.19 1.936 1.56 1.693 3.06-.243 1.498-1.395 2.558-2.573 2.367-1.178-.19-1.935-1.56-1.692-3.06zM17.51 8.649c.647-1.069 1.852-1.524 2.692-1.016.84.508.997 1.786.35 2.855-.646 1.069-1.85 1.524-2.69 1.016-.84-.508-.998-1.786-.351-2.855z",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconPet;